import CityPageTemplate from "../city-template/CityPageTemplate";
import { santaRosaConfig } from "./data";

export default function SantaRosaPage() {
  return <CityPageTemplate config={santaRosaConfig} />;
}